const getSmartScriptUrl = ({oneLinkURL, pageName}) => {
  const SMARTBANNER_KEY = 'mt-smartbanner'

  const mediaSource = {defaultValue: SMARTBANNER_KEY}
  const campaign = {keys: ['utm_campaign'], defaultValue: `${SMARTBANNER_KEY}_${pageName}`}
  const customSsUi = {paramKey: 'af_ss_ui', defaultValue: 'true'}

  try {
    const result = window.AF_SMART_SCRIPT.generateOneLinkURL({
      oneLinkURL,
      afParameters: {
        mediaSource,
        campaign,
        afCustom: [customSsUi]
      }
    })

    return result
  } catch (error) {
    console.error('Error generating SmartScript URL:', error)
  }
}

export {getSmartScriptUrl}
